/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 20.06.2016
 *
 */
import React from 'external/react';
import { CustomModal, CustomModalBody, CustomModalFooter } from './CustomModalComponents';
import { Button } from 'external/react-bootstrap';
import translation from '../utils/translation';
import PropTypes from 'external/prop-types';
import wrapWithFormContainer from './FormContainer';

const wrapWithCommonFormContainer = (FormComponent, includeFormLogic = true) => {

    const WrappedWithCommonFormContainer = props => {
        const { submitButtonText = 'OK', cancelButtonText = 'Abbrechen', formError } = props;

        let message = '';
        if (formError && formError.error) {
            message = formError.error.message;
            if (formError.exception && formError.exception === 'java.lang.SecurityException' && message.indexOf('Access denied to') === 0) {
                message = 'Versuchen Sie die Seite erneut zu laden und sich ggf. erneut anzumelden. ' + message;
            }
            if (formError.exception && formError.exception === 'de.lubw.fliwas.activationmatrix.exception.IndicatorInUseException') {
                if (message.indexOf('IndicatorInUseException') >= 0) {
                    message = 'Der Indikator wird noch verwendet und kann deswegen nicht gelöscht werden.';

                } else if (message.indexOf("UsedInDraft") >= 0) {
                    message = 'Der Indikator wird in einem Maßnahmen Entwurf verwendet und kann deswegen nicht gelöscht werden.';
                }
            }
        }

        return (
            <CustomModal
                show={props.isEditing}
                onHide={props.cancel}
                context={props.context}
                {...props.modalProps}
                hideFooter={true}
            >
                <CustomModalBody>
                    <FormComponent {...props}/>
                </CustomModalBody>
                <CustomModalFooter>
                    {props.cancel &&
                        <Button variant="primary" onClick={props.cancel}>
                            {cancelButtonText}
                        </Button>
                    }

                    {props.submit && !props.isSaving && props.isEdited && props.formValid &&
                        <Button variant="primary" onClick={props.submit}>
                            {submitButtonText}
                        </Button>
                    }
                    {props.submit && (props.isSaving || !(props.formValid && props.isEdited)) &&
                        <Button variant="primary" onClick={props.submit} disabled>
                            {submitButtonText}
                        </Button>
                    }

                </CustomModalFooter>
                {props.formError && props.formError.error &&
                    <div className="d-flex align-items-end flex-column px-3">
                        <h4>{translation.transException(props.formError.exception)}</h4>
                        <h4>{message}</h4>
                    </div>
                }
            </CustomModal>
        );
    };

    WrappedWithCommonFormContainer.propTypes = {
        ...FormComponent.propTypes,
        isSaving: PropTypes.bool,
        isEdited: PropTypes.bool,
        onChange: PropTypes.func,
        cancel: PropTypes.func,
        submit: PropTypes.func,
        reset: PropTypes.func,
        context: PropTypes.object,
        submitButtonText: PropTypes.string,
        cancelButtonText: PropTypes.string,
        modalProps: PropTypes.object,
        formError: PropTypes.object,
        formValidation: PropTypes.object,
        showReset: PropTypes.bool
    };

    return includeFormLogic ?
        wrapWithFormContainer(WrappedWithCommonFormContainer) :
        WrappedWithCommonFormContainer;
};

export default wrapWithCommonFormContainer;



// WEBPACK FOOTER //
// ./js/components/CommonFormContainer.jsx